import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { listItemRecipe } from './styles/list-item.styles';
import type { ListItemPropsInterface } from './types/list-item.types';

/**
 * @since 8.14.0
 */
export const ListItem = forwardRef<HTMLLIElement, ListItemPropsInterface>(
  (props: ListItemPropsInterface, forwardedRef) => {
    const { className, css: cssProp, ...rest } = props;

    const styles = css(listItemRecipe, cssProp);

    return (
      <li
        ref={forwardedRef}
        data-c11n-component="List.Item"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', 'c11n-semantic', styles, className)}
        {...rest}
      />
    );
  },
);

ListItem.displayName = 'List.Item';
